module.exports = __webpack_public_path__ + "static/gs-49fa4d63f13a912b2bd736fa8bc96935.svg";